import * as configEnglish from '../config/configEnglish';
import * as configChicken from '../config/configChicken';
import * as configChickenVitality from '../config/configChickenVitality';
import * as configChickenMeditation from '../config/configChickenMeditation';
import * as configMall from '../config/configMall';
import * as configChickenReadPlan from '../config/configChickenReadPlan';
import * as configMillionaire from '../config/configMillionaire';
import * as configReading from '../config/configReading';
import * as configNewVitality from '../config/configNewVitality';
import * as configTVitality from '../config/configTVitality';
import * as configTraining from '../config/configTraining';

export default {
	configEnglish,
	configChicken,
	configChickenVitality,
	configChickenMeditation,
	configMall,
	configChickenReadPlan,
	configMillionaire,
	configReading,
	configNewVitality,
	configTVitality,
	configTraining
};



// WEBPACK FOOTER //
// ./src/config/index.js